// Recipe data structures and sample data from Excel

export const recipesData = [
  {
    id: "1",
    code: "RCP-001",
    name: "Chilli Garlic Fried Rice Veg",
    itemName: "Fried Rice",
    variationName: "Chilli Garlic Veg",
    category: "Rice",
    cuisine: "Indo-Chinese",
    yield: 295,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Long Grain Basmati Rice", rate: 171.43, quantity: 180, unit: "GM", fraction: 1000, amount: 30.86 },
      { id: "2", ingredientName: "Green Beans", rate: 60, quantity: 30, unit: "GM", fraction: 1000, amount: 1.80 },
      { id: "3", ingredientName: "Carrot", rate: 38, quantity: 30, unit: "GM", fraction: 1000, amount: 1.14 },
      { id: "4", ingredientName: "Aromat", rate: 0, quantity: 8, unit: "GM", fraction: 800, amount: 0.00 },
      { id: "5", ingredientName: "Breakfast Sugar", rate: 80, quantity: 1, unit: "GM", fraction: 1000, amount: 0.08 },
      { id: "6", ingredientName: "Salt", rate: 25, quantity: 2, unit: "GM", fraction: 1000, amount: 0.05 },
      { id: "7", ingredientName: "White Pepper", rate: 166.67, quantity: 1, unit: "GM", fraction: 100, amount: 1.67 },
      { id: "8", ingredientName: "Spring Onion", rate: 80, quantity: 8, unit: "GM", fraction: 1000, amount: 0.64 },
      { id: "9", ingredientName: "Garlic", rate: 65, quantity: 5, unit: "GM", fraction: 1000, amount: 0.33 },
      { id: "10", ingredientName: "Chilli Paste", rate: 1053.51, quantity: 8, unit: "GM", fraction: 3400, amount: 2.48 },
      { id: "11", ingredientName: "Light Soy", rate: 180, quantity: 3, unit: "ML", fraction: 500, amount: 1.08 },
      { id: "12", ingredientName: "Tomato Ketchup", rate: 128, quantity: 2, unit: "GM", fraction: 1000, amount: 0.26 },
      { id: "13", ingredientName: "White Vinegar", rate: 40, quantity: 2, unit: "ML", fraction: 610, amount: 0.13 },
      { id: "14", ingredientName: "Brown Garlic", rate: 317.38, quantity: 5, unit: "GM", fraction: 2500, amount: 0.63 },
      { id: "15", ingredientName: "Refined Oil", rate: 2523.81, quantity: 10, unit: "ML", fraction: 15000, amount: 1.68 },
    ],
    landingCost: 42.82,
    sellingPrice: 375.00,
    costPercentage: 11.42,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "2",
    code: "RCP-002",
    name: "Veg Fried Rice",
    itemName: "Fried Rice",
    variationName: "Veg",
    category: "Rice",
    cuisine: "Indo-Chinese",
    yield: 280,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Long Grain Basmati Rice", rate: 171.43, quantity: 190, unit: "GM", fraction: 1000, amount: 32.57 },
      { id: "2", ingredientName: "Green Beans", rate: 60, quantity: 30, unit: "GM", fraction: 1000, amount: 1.80 },
      { id: "3", ingredientName: "Carrot", rate: 38, quantity: 30, unit: "GM", fraction: 1000, amount: 1.14 },
      { id: "4", ingredientName: "Breakfast Sugar", rate: 80, quantity: 1, unit: "GM", fraction: 1000, amount: 0.08 },
      { id: "5", ingredientName: "Salt", rate: 25, quantity: 2, unit: "GM", fraction: 1000, amount: 0.05 },
      { id: "6", ingredientName: "White Pepper", rate: 166.67, quantity: 1, unit: "GM", fraction: 100, amount: 1.67 },
      { id: "7", ingredientName: "Spring Onion", rate: 80, quantity: 8, unit: "GM", fraction: 1000, amount: 0.64 },
      { id: "8", ingredientName: "Refined Oil", rate: 2523.81, quantity: 10, unit: "ML", fraction: 15000, amount: 1.68 },
    ],
    landingCost: 39.63,
    sellingPrice: 375.00,
    costPercentage: 10.57,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "3",
    code: "RCP-003",
    name: "Chowmein Veg",
    itemName: "Chowmein",
    variationName: "Veg",
    category: "Noodles",
    cuisine: "Indo-Chinese",
    yield: 320,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Yellow Noodle", rate: 60, quantity: 170, unit: "GM", fraction: 1000, amount: 10.20 },
      { id: "2", ingredientName: "Onion Shredded", rate: 20, quantity: 10, unit: "GM", fraction: 1000, amount: 0.20 },
      { id: "3", ingredientName: "Chopped Garlic", rate: 65, quantity: 7, unit: "GM", fraction: 1000, amount: 0.46 },
      { id: "4", ingredientName: "Chopped Ginger", rate: 50, quantity: 5, unit: "GM", fraction: 1000, amount: 0.25 },
      { id: "5", ingredientName: "Carrot Shredded", rate: 38, quantity: 15, unit: "GM", fraction: 1000, amount: 0.57 },
      { id: "6", ingredientName: "Bok-Choy Shredded", rate: 90, quantity: 15, unit: "GM", fraction: 1000, amount: 1.35 },
      { id: "7", ingredientName: "Green Capsicum", rate: 35, quantity: 10, unit: "GM", fraction: 1000, amount: 0.35 },
      { id: "8", ingredientName: "Chinese Cabbage", rate: 80, quantity: 15, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "9", ingredientName: "Bell Pepper Shredded", rate: 110, quantity: 15, unit: "GM", fraction: 1000, amount: 1.65 },
      { id: "10", ingredientName: "Spring Onion Dice", rate: 80, quantity: 10, unit: "GM", fraction: 1000, amount: 0.80 },
      { id: "11", ingredientName: "Dark Soya Sauce", rate: 2950, quantity: 4, unit: "ML", fraction: 15000, amount: 0.79 },
      { id: "12", ingredientName: "Light Soya Sauce", rate: 3125, quantity: 3, unit: "ML", fraction: 15000, amount: 0.63 },
      { id: "13", ingredientName: "White Vinegar", rate: 40, quantity: 4, unit: "ML", fraction: 610, amount: 0.26 },
      { id: "14", ingredientName: "Chilli Paste", rate: 1053.51, quantity: 5, unit: "GM", fraction: 3400, amount: 1.55 },
      { id: "15", ingredientName: "Green Chilli Sauce", rate: 60, quantity: 5, unit: "GM", fraction: 610, amount: 0.49 },
      { id: "16", ingredientName: "Roasted Chicken Broth Powder", rate: 250, quantity: 5, unit: "GM", fraction: 800, amount: 1.56 },
      { id: "17", ingredientName: "Indian Cabbage", rate: 30, quantity: 10, unit: "GM", fraction: 1000, amount: 0.30 },
      { id: "18", ingredientName: "Green Chilli", rate: 34, quantity: 2, unit: "GM", fraction: 1000, amount: 0.07 },
      { id: "19", ingredientName: "Refined Oil", rate: 2523.81, quantity: 10, unit: "ML", fraction: 15000, amount: 1.68 },
    ],
    landingCost: 24.35,
    sellingPrice: 375.00,
    costPercentage: 6.49,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "4",
    code: "RCP-004",
    name: "Chilli Garlic Noodles Veg",
    itemName: "Noodles",
    variationName: "Chilli Garlic Veg",
    category: "Noodles",
    cuisine: "Indo-Chinese",
    yield: 300,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Yellow Noodles", rate: 60, quantity: 170, unit: "GM", fraction: 1000, amount: 10.20 },
      { id: "2", ingredientName: "Onion Shredded", rate: 20, quantity: 10, unit: "GM", fraction: 1000, amount: 0.20 },
      { id: "3", ingredientName: "Chopped Garlic", rate: 65, quantity: 7, unit: "GM", fraction: 1000, amount: 0.46 },
      { id: "4", ingredientName: "Carrot Shredded", rate: 38, quantity: 5, unit: "GM", fraction: 1000, amount: 0.19 },
      { id: "5", ingredientName: "Bok-Choy Shredded", rate: 90, quantity: 10, unit: "GM", fraction: 1000, amount: 0.90 },
      { id: "6", ingredientName: "Green Capsicum", rate: 35, quantity: 10, unit: "GM", fraction: 1000, amount: 0.35 },
      { id: "7", ingredientName: "Chinese Cabbage", rate: 80, quantity: 8, unit: "GM", fraction: 1000, amount: 0.64 },
      { id: "8", ingredientName: "Bell Pepper Shredded", rate: 110, quantity: 10, unit: "GM", fraction: 1000, amount: 1.10 },
      { id: "9", ingredientName: "Spring Onion Dice", rate: 80, quantity: 10, unit: "GM", fraction: 1000, amount: 0.80 },
      { id: "10", ingredientName: "White Vinegar", rate: 40, quantity: 8, unit: "ML", fraction: 610, amount: 0.52 },
      { id: "11", ingredientName: "Chilli Paste", rate: 1053.51, quantity: 5, unit: "GM", fraction: 3400, amount: 1.55 },
      { id: "12", ingredientName: "Green Chilli Sauce", rate: 220, quantity: 3, unit: "GM", fraction: 610, amount: 1.08 },
      { id: "13", ingredientName: "Roasted Chicken Broth Powder", rate: 250, quantity: 4, unit: "GM", fraction: 800, amount: 1.25 },
      { id: "14", ingredientName: "Indian Cabbage", rate: 30, quantity: 20, unit: "GM", fraction: 1000, amount: 0.60 },
      { id: "15", ingredientName: "Refined Oil", rate: 2523.81, quantity: 10, unit: "ML", fraction: 15000, amount: 1.68 },
      { id: "16", ingredientName: "Spring Onions", rate: 80, quantity: 8, unit: "GM", fraction: 1000, amount: 0.64 },
      { id: "17", ingredientName: "Brown Garlic", rate: 317.38, quantity: 5, unit: "GM", fraction: 2500, amount: 0.63 },
    ],
    landingCost: 22.80,
    sellingPrice: 375.00,
    costPercentage: 6.08,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "5",
    code: "RCP-005",
    name: "Hakka Noodles Veg",
    itemName: "Hakka Noodles",
    variationName: "Veg",
    category: "Noodles",
    cuisine: "Indo-Chinese",
    yield: 300,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Yellow Noodle", rate: 60, quantity: 170, unit: "GM", fraction: 1000, amount: 10.20 },
      { id: "2", ingredientName: "Onion Shredded", rate: 20, quantity: 10, unit: "GM", fraction: 1000, amount: 0.20 },
      { id: "3", ingredientName: "Carrot Shredded", rate: 38, quantity: 5, unit: "GM", fraction: 1000, amount: 0.19 },
      { id: "4", ingredientName: "Bok-Choy Shredded", rate: 90, quantity: 20, unit: "GM", fraction: 1000, amount: 1.80 },
      { id: "5", ingredientName: "Green Capsicum", rate: 35, quantity: 10, unit: "GM", fraction: 1000, amount: 0.35 },
      { id: "6", ingredientName: "Chinese Cabbage", rate: 80, quantity: 20, unit: "GM", fraction: 1000, amount: 1.60 },
      { id: "7", ingredientName: "Bell Pepper Shredded", rate: 110, quantity: 10, unit: "GM", fraction: 1000, amount: 1.10 },
      { id: "8", ingredientName: "Spring Onion Dice", rate: 80, quantity: 10, unit: "GM", fraction: 1000, amount: 0.80 },
      { id: "9", ingredientName: "Roasted Chicken Broth Powder", rate: 250, quantity: 5, unit: "GM", fraction: 800, amount: 1.56 },
      { id: "10", ingredientName: "Indian Cabbage", rate: 30, quantity: 30, unit: "GM", fraction: 1000, amount: 0.90 },
      { id: "11", ingredientName: "Refined Oil", rate: 2523.81, quantity: 10, unit: "ML", fraction: 15000, amount: 1.68 },
    ],
    landingCost: 20.39,
    sellingPrice: 375.00,
    costPercentage: 5.44,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "6",
    code: "RCP-006",
    name: "Jasmine Rice Steam",
    itemName: "Jasmine Rice",
    variationName: "Steam",
    category: "Rice",
    cuisine: "Thai",
    yield: 380,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Jasmine Rice", rate: 630, quantity: 200, unit: "GM", fraction: 2000, amount: 63.00 },
      { id: "2", ingredientName: "Galangal", rate: 270, quantity: 8, unit: "GM", fraction: 1000, amount: 2.16 },
      { id: "3", ingredientName: "Lemon Grass", rate: 120, quantity: 9, unit: "ML", fraction: 1000, amount: 1.08 },
      { id: "4", ingredientName: "Lemon Leaf", rate: 800, quantity: 3, unit: "GM", fraction: 1000, amount: 2.40 },
      { id: "5", ingredientName: "Refined Oil", rate: 2523.81, quantity: 7, unit: "ML", fraction: 15000, amount: 1.18 },
    ],
    landingCost: 69.82,
    sellingPrice: 329.00,
    costPercentage: 21.22,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "7",
    code: "RCP-007",
    name: "Mushroom Dragon Roll",
    itemName: "Dragon Roll",
    variationName: "Mushroom",
    category: "Sushi",
    cuisine: "Japanese",
    yield: 200,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Rice", rate: 509.52, quantity: 100, unit: "GM", fraction: 15000, amount: 3.40 },
      { id: "2", ingredientName: "Avocado", rate: 750, quantity: 20, unit: "GM", fraction: 1000, amount: 15.00 },
      { id: "3", ingredientName: "Bottom Mushroom", rate: 65, quantity: 16, unit: "GM", fraction: 20, amount: 52.00 },
      { id: "4", ingredientName: "Shiitake Mushroom", rate: 350, quantity: 15, unit: "GM", fraction: 1000, amount: 5.25 },
      { id: "5", ingredientName: "Mayo", rate: 166.67, quantity: 10, unit: "GM", fraction: 100, amount: 16.67 },
      { id: "6", ingredientName: "Truffle Oil", rate: 900, quantity: 2, unit: "ML", fraction: 1000, amount: 1.80 },
      { id: "7", ingredientName: "Ginger", rate: 50, quantity: 2, unit: "GM", fraction: 1000, amount: 0.10 },
      { id: "8", ingredientName: "Garlic", rate: 48, quantity: 2, unit: "GM", fraction: 1000, amount: 0.10 },
      { id: "9", ingredientName: "Chilli Paste", rate: 50, quantity: 30, unit: "GM", fraction: 1000, amount: 1.50 },
      { id: "10", ingredientName: "Dark Soya", rate: 120, quantity: 20, unit: "ML", fraction: 1000, amount: 2.40 },
      { id: "11", ingredientName: "Aromat", rate: 150, quantity: 15, unit: "GM", fraction: 2000, amount: 1.13 },
      { id: "12", ingredientName: "Nori Sheet", rate: 400, quantity: 5, unit: "GM", fraction: 1000, amount: 2.00 },
    ],
    landingCost: 101.33,
    sellingPrice: 599.00,
    costPercentage: 16.92,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "8",
    code: "RCP-008",
    name: "Thai Basil Dimsum",
    itemName: "Dimsum",
    variationName: "Thai Basil",
    category: "Dimsum",
    cuisine: "Thai-Chinese",
    yield: 200,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Broccoli", rate: 60, quantity: 25, unit: "GM", fraction: 1000, amount: 1.50 },
      { id: "2", ingredientName: "Green Zucchini", rate: 38, quantity: 20, unit: "GM", fraction: 1000, amount: 0.76 },
      { id: "3", ingredientName: "Yellow Zucchini", rate: 30, quantity: 15, unit: "GM", fraction: 1000, amount: 0.45 },
      { id: "4", ingredientName: "Carrot", rate: 105, quantity: 20, unit: "GM", fraction: 1000, amount: 2.10 },
      { id: "5", ingredientName: "Basil", rate: 20, quantity: 5, unit: "GM", fraction: 1000, amount: 0.10 },
      { id: "6", ingredientName: "Water Chestnut", rate: 285, quantity: 20, unit: "GM", fraction: 1000, amount: 5.70 },
      { id: "7", ingredientName: "Potato Starch", rate: 140, quantity: 20, unit: "GM", fraction: 1000, amount: 2.80 },
      { id: "8", ingredientName: "Wheat Starch", rate: 50, quantity: 20, unit: "GM", fraction: 1000, amount: 1.00 },
      { id: "9", ingredientName: "Chilli Paste", rate: 35, quantity: 20, unit: "GM", fraction: 1000, amount: 0.70 },
      { id: "10", ingredientName: "Aromat", rate: 25, quantity: 10, unit: "GM", fraction: 1000, amount: 0.25 },
      { id: "11", ingredientName: "Oyster Sauce", rate: 680, quantity: 20, unit: "GM", fraction: 2000, amount: 6.80 },
      { id: "12", ingredientName: "Seasoning Oil", rate: 35, quantity: 1, unit: "ML", fraction: 1000, amount: 0.04 },
      { id: "13", ingredientName: "Ginger", rate: 48, quantity: 2, unit: "GM", fraction: 1000, amount: 0.10 },
      { id: "14", ingredientName: "Garlic", rate: 50, quantity: 4, unit: "GM", fraction: 1000, amount: 0.20 },
    ],
    landingCost: 22.49,
    sellingPrice: 345.00,
    costPercentage: 6.52,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "9",
    code: "RCP-009",
    name: "Crystal Mushroom Dimsum",
    itemName: "Dimsum",
    variationName: "Crystal Mushroom",
    category: "Dimsum",
    cuisine: "Chinese",
    yield: 195,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Potato Starch", rate: 60, quantity: 50, unit: "GM", fraction: 1000, amount: 3.00 },
      { id: "2", ingredientName: "Bottom Mushroom", rate: 38, quantity: 50, unit: "GM", fraction: 1000, amount: 1.90 },
      { id: "3", ingredientName: "Shiitake Mushroom", rate: 30, quantity: 40, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "4", ingredientName: "Black Fungus", rate: 105, quantity: 20, unit: "GM", fraction: 1000, amount: 2.10 },
      { id: "5", ingredientName: "White Shiitake", rate: 20, quantity: 20, unit: "GM", fraction: 1000, amount: 0.40 },
      { id: "6", ingredientName: "Coriander Chopped", rate: 285, quantity: 5, unit: "GM", fraction: 1000, amount: 1.42 },
      { id: "7", ingredientName: "Oyster Sauce", rate: 140, quantity: 10, unit: "GM", fraction: 1000, amount: 1.40 },
      { id: "8", ingredientName: "Aromat Powder", rate: 50, quantity: 10, unit: "GM", fraction: 1000, amount: 0.50 },
      { id: "9", ingredientName: "Garlic", rate: 35, quantity: 4, unit: "GM", fraction: 1000, amount: 0.14 },
      { id: "10", ingredientName: "Ginger", rate: 25, quantity: 2, unit: "GM", fraction: 1000, amount: 0.05 },
      { id: "11", ingredientName: "Maggi Seasoning", rate: 680, quantity: 2, unit: "ML", fraction: 2000, amount: 0.68 },
      { id: "12", ingredientName: "Sesame Oil", rate: 35, quantity: 1, unit: "ML", fraction: 1000, amount: 0.04 },
    ],
    landingCost: 12.83,
    sellingPrice: 345.00,
    costPercentage: 3.72,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "10",
    code: "RCP-010",
    name: "Khow Suey",
    itemName: "Khow Suey",
    category: "Soup",
    cuisine: "Burmese",
    yield: 350,
    yieldUnit: "ml",
    ingredients: [
      { id: "1", ingredientName: "Coconut Milk Powder", rate: 60, quantity: 40, unit: "GM", fraction: 1000, amount: 2.40 },
      { id: "2", ingredientName: "Madras Curry Powder", rate: 38, quantity: 2, unit: "GM", fraction: 1000, amount: 0.08 },
      { id: "3", ingredientName: "Oil", rate: 30, quantity: 2, unit: "ML", fraction: 1000, amount: 0.06 },
      { id: "4", ingredientName: "Lemon Grass", rate: 105, quantity: 0.5, unit: "GM", fraction: 1000, amount: 0.05 },
      { id: "5", ingredientName: "Thai Ginger", rate: 20, quantity: 0.5, unit: "GM", fraction: 1000, amount: 0.01 },
      { id: "6", ingredientName: "Lemon", rate: 285, quantity: 0.5, unit: "NO", fraction: 1000, amount: 0.14 },
      { id: "7", ingredientName: "Broccoli", rate: 140, quantity: 5, unit: "GM", fraction: 1000, amount: 0.70 },
      { id: "8", ingredientName: "Baby Corn", rate: 50, quantity: 5, unit: "GM", fraction: 1000, amount: 0.25 },
      { id: "9", ingredientName: "Carrot", rate: 35, quantity: 5, unit: "GM", fraction: 1000, amount: 0.18 },
      { id: "10", ingredientName: "Chopped Coriander", rate: 25, quantity: 8, unit: "GM", fraction: 1000, amount: 0.20 },
      { id: "11", ingredientName: "Aromat", rate: 680, quantity: 8, unit: "GM", fraction: 2000, amount: 2.72 },
      { id: "12", ingredientName: "Fried Garlic", rate: 35, quantity: 1, unit: "GM", fraction: 1000, amount: 0.04 },
      { id: "13", ingredientName: "Boiled Noodle", rate: 48, quantity: 5, unit: "GM", fraction: 1000, amount: 0.24 },
    ],
    landingCost: 7.06,
    sellingPrice: 345.00,
    costPercentage: 2.05,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "11",
    code: "RCP-011",
    name: "Manchow Soup",
    itemName: "Manchow",
    category: "Soup",
    cuisine: "Indo-Chinese",
    yield: 300,
    yieldUnit: "ml",
    ingredients: [
      { id: "1", ingredientName: "Oil", rate: 60, quantity: 3, unit: "ML", fraction: 1000, amount: 0.18 },
      { id: "2", ingredientName: "Garlic", rate: 38, quantity: 2, unit: "GM", fraction: 1000, amount: 0.08 },
      { id: "3", ingredientName: "Aromat", rate: 30, quantity: 8, unit: "GM", fraction: 1000, amount: 0.24 },
      { id: "4", ingredientName: "Coriander", rate: 105, quantity: 2, unit: "GM", fraction: 1000, amount: 0.21 },
      { id: "5", ingredientName: "Cabbage", rate: 20, quantity: 5, unit: "GM", fraction: 1000, amount: 0.10 },
      { id: "6", ingredientName: "Carrot", rate: 285, quantity: 5, unit: "GM", fraction: 1000, amount: 1.42 },
      { id: "7", ingredientName: "Mushroom", rate: 140, quantity: 5, unit: "GM", fraction: 1000, amount: 0.70 },
      { id: "8", ingredientName: "Fried Noodle", rate: 50, quantity: 25, unit: "GM", fraction: 1000, amount: 1.25 },
      { id: "9", ingredientName: "Potato Starch", rate: 35, quantity: 1, unit: "GM", fraction: 1000, amount: 0.04 },
      { id: "10", ingredientName: "White Pepper", rate: 25, quantity: 0.5, unit: "GM", fraction: 1000, amount: 0.01 },
      { id: "11", ingredientName: "Fried Garlic", rate: 680, quantity: 0.5, unit: "GM", fraction: 2000, amount: 0.17 },
    ],
    landingCost: 4.40,
    sellingPrice: 345.00,
    costPercentage: 1.27,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "12",
    code: "RCP-012",
    name: "Sweet Corn Soup",
    itemName: "Sweet Corn",
    category: "Soup",
    cuisine: "Indo-Chinese",
    yield: 300,
    yieldUnit: "ml",
    ingredients: [
      { id: "1", ingredientName: "Sweet Corn", rate: 70, quantity: 5, unit: "GM", fraction: 1000, amount: 0.35 },
      { id: "2", ingredientName: "Sweet Corn Cream", rate: 35, quantity: 10, unit: "GM", fraction: 1000, amount: 0.35 },
      { id: "3", ingredientName: "Spring Onion", rate: 48, quantity: 2, unit: "GM", fraction: 1000, amount: 0.10 },
      { id: "4", ingredientName: "White Pepper", rate: 75, quantity: 0.5, unit: "GM", fraction: 1000, amount: 0.04 },
      { id: "5", ingredientName: "Sugar", rate: 25, quantity: 10, unit: "GM", fraction: 1000, amount: 0.25 },
      { id: "6", ingredientName: "Aromat", rate: 36, quantity: 8, unit: "GM", fraction: 1000, amount: 0.29 },
    ],
    landingCost: 1.37,
    sellingPrice: 215.00,
    costPercentage: 0.64,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "13",
    code: "RCP-013",
    name: "Hot & Sour Soup",
    itemName: "Hot & Sour",
    category: "Soup",
    cuisine: "Indo-Chinese",
    yield: 300,
    yieldUnit: "ml",
    ingredients: [
      { id: "1", ingredientName: "Shiitake", rate: 70, quantity: 5, unit: "GM", fraction: 1000, amount: 0.35 },
      { id: "2", ingredientName: "Bamboo Shoot", rate: 35, quantity: 3, unit: "GM", fraction: 1000, amount: 0.11 },
      { id: "3", ingredientName: "Black Pepper", rate: 48, quantity: 0.5, unit: "GM", fraction: 1000, amount: 0.02 },
      { id: "4", ingredientName: "Cabbage", rate: 75, quantity: 2, unit: "GM", fraction: 1000, amount: 0.15 },
      { id: "5", ingredientName: "Carrot", rate: 25, quantity: 2, unit: "GM", fraction: 1000, amount: 0.05 },
      { id: "6", ingredientName: "Aromat", rate: 36, quantity: 8, unit: "GM", fraction: 1000, amount: 0.29 },
      { id: "7", ingredientName: "Black Fungus", rate: 59.43, quantity: 3, unit: "GM", fraction: 100, amount: 1.78 },
      { id: "8", ingredientName: "Vinegar", rate: 390, quantity: 2, unit: "ML", fraction: 1000, amount: 0.78 },
      { id: "9", ingredientName: "Chilli Paste", rate: 295, quantity: 0.5, unit: "GM", fraction: 1000, amount: 0.15 },
      { id: "10", ingredientName: "Tofu", rate: 35, quantity: 3, unit: "GM", fraction: 1000, amount: 0.11 },
    ],
    landingCost: 3.78,
    sellingPrice: 215.00,
    costPercentage: 1.76,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "14",
    code: "RCP-014",
    name: "Cottage Cheese Satay",
    itemName: "Paneer Satay",
    variationName: "Cottage Cheese",
    category: "Starters",
    cuisine: "Thai",
    yield: 297,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Paneer", rate: 70, quantity: 250, unit: "GM", fraction: 1000, amount: 17.50 },
      { id: "2", ingredientName: "Coconut Milk Powder", rate: 35, quantity: 15, unit: "GM", fraction: 1000, amount: 0.53 },
      { id: "3", ingredientName: "Peanut Butter Sauce", rate: 48, quantity: 10, unit: "GM", fraction: 1000, amount: 0.48 },
      { id: "4", ingredientName: "Aromat", rate: 75, quantity: 10, unit: "GM", fraction: 1000, amount: 0.75 },
      { id: "5", ingredientName: "BBQ Sauce", rate: 25, quantity: 5, unit: "GM", fraction: 1000, amount: 0.13 },
      { id: "6", ingredientName: "Sugar", rate: 36, quantity: 5, unit: "GM", fraction: 1000, amount: 0.18 },
      { id: "7", ingredientName: "Thai Herbs", rate: 59.43, quantity: 2, unit: "GM", fraction: 100, amount: 1.19 },
    ],
    landingCost: 20.75,
    sellingPrice: 399.00,
    costPercentage: 5.20,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "15",
    code: "RCP-015",
    name: "Rainbow Roll",
    itemName: "Rainbow Roll",
    category: "Sushi",
    cuisine: "Japanese",
    yield: 200,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Sushi Rice", rate: 60, quantity: 100, unit: "GM", fraction: 1000, amount: 6.00 },
      { id: "2", ingredientName: "Nori Sheet", rate: 38, quantity: 1, unit: "NO", fraction: 1000, amount: 0.04 },
      { id: "3", ingredientName: "Radish Pickle", rate: 30, quantity: 15, unit: "GM", fraction: 1000, amount: 0.45 },
      { id: "4", ingredientName: "Edamame", rate: 105, quantity: 5, unit: "GM", fraction: 1000, amount: 0.53 },
      { id: "5", ingredientName: "Carrot", rate: 20, quantity: 15, unit: "GM", fraction: 1000, amount: 0.30 },
      { id: "6", ingredientName: "Cucumber", rate: 285, quantity: 15, unit: "GM", fraction: 1000, amount: 4.27 },
      { id: "7", ingredientName: "Asparagus", rate: 140, quantity: 10, unit: "GM", fraction: 1000, amount: 1.40 },
      { id: "8", ingredientName: "Spicy Mayo", rate: 50, quantity: 8, unit: "GM", fraction: 1000, amount: 0.40 },
      { id: "9", ingredientName: "Avocado", rate: 35, quantity: 15, unit: "GM", fraction: 1000, amount: 0.53 },
      { id: "10", ingredientName: "Edible Flower", rate: 25, quantity: 2, unit: "GM", fraction: 1000, amount: 0.05 },
      { id: "11", ingredientName: "Wasabi Paste", rate: 680, quantity: 10, unit: "GM", fraction: 2000, amount: 3.40 },
      { id: "12", ingredientName: "Pickle Ginger", rate: 35, quantity: 10, unit: "GM", fraction: 1000, amount: 0.35 },
      { id: "13", ingredientName: "Kikoman Soya", rate: 48, quantity: 25, unit: "ML", fraction: 1000, amount: 1.20 },
    ],
    landingCost: 18.91,
    sellingPrice: 345.00,
    costPercentage: 5.48,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  // =====================================================
  // PAGE 2 - INDIAN MAIN COURSE
  // =====================================================
  {
    id: "16",
    code: "RCP-016",
    name: "Paneer Butter Masala",
    itemName: "Paneer Butter Masala",
    category: "Main Course",
    cuisine: "Indian",
    yield: 350,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Paneer", rate: 320, quantity: 180, unit: "GM", fraction: 1000, amount: 57.60 },
      { id: "2", ingredientName: "Tomato Puree", rate: 80, quantity: 100, unit: "GM", fraction: 1000, amount: 8.00 },
      { id: "3", ingredientName: "Cashew Paste", rate: 850, quantity: 30, unit: "GM", fraction: 1000, amount: 25.50 },
      { id: "4", ingredientName: "Butter", rate: 480, quantity: 30, unit: "GM", fraction: 1000, amount: 14.40 },
      { id: "5", ingredientName: "Fresh Cream", rate: 280, quantity: 30, unit: "ML", fraction: 1000, amount: 8.40 },
      { id: "6", ingredientName: "Ginger Garlic Paste", rate: 120, quantity: 10, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "7", ingredientName: "Red Chilli Powder", rate: 350, quantity: 5, unit: "GM", fraction: 1000, amount: 1.75 },
      { id: "8", ingredientName: "Kasuri Methi", rate: 600, quantity: 3, unit: "GM", fraction: 1000, amount: 1.80 },
      { id: "9", ingredientName: "Garam Masala", rate: 450, quantity: 3, unit: "GM", fraction: 1000, amount: 1.35 },
      { id: "10", ingredientName: "Salt", rate: 25, quantity: 5, unit: "GM", fraction: 1000, amount: 0.13 },
      { id: "11", ingredientName: "Sugar", rate: 80, quantity: 5, unit: "GM", fraction: 1000, amount: 0.40 },
    ],
    landingCost: 120.53,
    sellingPrice: 425.00,
    costPercentage: 28.36,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "17",
    code: "RCP-017",
    name: "Dal Makhani",
    itemName: "Dal Makhani",
    category: "Main Course",
    cuisine: "Indian",
    yield: 300,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Black Urad Dal", rate: 180, quantity: 80, unit: "GM", fraction: 1000, amount: 14.40 },
      { id: "2", ingredientName: "Rajma", rate: 140, quantity: 20, unit: "GM", fraction: 1000, amount: 2.80 },
      { id: "3", ingredientName: "Tomato Puree", rate: 80, quantity: 60, unit: "GM", fraction: 1000, amount: 4.80 },
      { id: "4", ingredientName: "Butter", rate: 480, quantity: 40, unit: "GM", fraction: 1000, amount: 19.20 },
      { id: "5", ingredientName: "Fresh Cream", rate: 280, quantity: 25, unit: "ML", fraction: 1000, amount: 7.00 },
      { id: "6", ingredientName: "Ginger Garlic Paste", rate: 120, quantity: 8, unit: "GM", fraction: 1000, amount: 0.96 },
      { id: "7", ingredientName: "Red Chilli Powder", rate: 350, quantity: 3, unit: "GM", fraction: 1000, amount: 1.05 },
      { id: "8", ingredientName: "Kasuri Methi", rate: 600, quantity: 2, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "9", ingredientName: "Garam Masala", rate: 450, quantity: 2, unit: "GM", fraction: 1000, amount: 0.90 },
      { id: "10", ingredientName: "Salt", rate: 25, quantity: 4, unit: "GM", fraction: 1000, amount: 0.10 },
    ],
    landingCost: 52.41,
    sellingPrice: 345.00,
    costPercentage: 15.19,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "18",
    code: "RCP-018",
    name: "Palak Paneer",
    itemName: "Palak Paneer",
    category: "Main Course",
    cuisine: "Indian",
    yield: 320,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Paneer", rate: 320, quantity: 150, unit: "GM", fraction: 1000, amount: 48.00 },
      { id: "2", ingredientName: "Spinach", rate: 60, quantity: 200, unit: "GM", fraction: 1000, amount: 12.00 },
      { id: "3", ingredientName: "Onion", rate: 35, quantity: 40, unit: "GM", fraction: 1000, amount: 1.40 },
      { id: "4", ingredientName: "Tomato", rate: 40, quantity: 30, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "5", ingredientName: "Ginger Garlic Paste", rate: 120, quantity: 10, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "6", ingredientName: "Green Chilli", rate: 80, quantity: 5, unit: "GM", fraction: 1000, amount: 0.40 },
      { id: "7", ingredientName: "Cumin Seeds", rate: 280, quantity: 3, unit: "GM", fraction: 1000, amount: 0.84 },
      { id: "8", ingredientName: "Garam Masala", rate: 450, quantity: 2, unit: "GM", fraction: 1000, amount: 0.90 },
      { id: "9", ingredientName: "Fresh Cream", rate: 280, quantity: 20, unit: "ML", fraction: 1000, amount: 5.60 },
      { id: "10", ingredientName: "Oil", rate: 150, quantity: 15, unit: "ML", fraction: 1000, amount: 2.25 },
      { id: "11", ingredientName: "Salt", rate: 25, quantity: 4, unit: "GM", fraction: 1000, amount: 0.10 },
    ],
    landingCost: 73.89,
    sellingPrice: 395.00,
    costPercentage: 18.71,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "19",
    code: "RCP-019",
    name: "Kadai Paneer",
    itemName: "Kadai Paneer",
    category: "Main Course",
    cuisine: "Indian",
    yield: 340,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Paneer", rate: 320, quantity: 180, unit: "GM", fraction: 1000, amount: 57.60 },
      { id: "2", ingredientName: "Capsicum", rate: 80, quantity: 50, unit: "GM", fraction: 1000, amount: 4.00 },
      { id: "3", ingredientName: "Onion", rate: 35, quantity: 50, unit: "GM", fraction: 1000, amount: 1.75 },
      { id: "4", ingredientName: "Tomato", rate: 40, quantity: 80, unit: "GM", fraction: 1000, amount: 3.20 },
      { id: "5", ingredientName: "Ginger Garlic Paste", rate: 120, quantity: 10, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "6", ingredientName: "Kadai Masala", rate: 380, quantity: 8, unit: "GM", fraction: 1000, amount: 3.04 },
      { id: "7", ingredientName: "Coriander Powder", rate: 200, quantity: 5, unit: "GM", fraction: 1000, amount: 1.00 },
      { id: "8", ingredientName: "Red Chilli Powder", rate: 350, quantity: 4, unit: "GM", fraction: 1000, amount: 1.40 },
      { id: "9", ingredientName: "Kasuri Methi", rate: 600, quantity: 2, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "10", ingredientName: "Fresh Coriander", rate: 120, quantity: 10, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "11", ingredientName: "Oil", rate: 150, quantity: 20, unit: "ML", fraction: 1000, amount: 3.00 },
      { id: "12", ingredientName: "Salt", rate: 25, quantity: 4, unit: "GM", fraction: 1000, amount: 0.10 },
    ],
    landingCost: 78.69,
    sellingPrice: 425.00,
    costPercentage: 18.52,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "20",
    code: "RCP-020",
    name: "Shahi Paneer",
    itemName: "Shahi Paneer",
    category: "Main Course",
    cuisine: "Indian",
    yield: 350,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Paneer", rate: 320, quantity: 180, unit: "GM", fraction: 1000, amount: 57.60 },
      { id: "2", ingredientName: "Onion Paste", rate: 45, quantity: 60, unit: "GM", fraction: 1000, amount: 2.70 },
      { id: "3", ingredientName: "Cashew Paste", rate: 850, quantity: 35, unit: "GM", fraction: 1000, amount: 29.75 },
      { id: "4", ingredientName: "Tomato Puree", rate: 80, quantity: 50, unit: "GM", fraction: 1000, amount: 4.00 },
      { id: "5", ingredientName: "Fresh Cream", rate: 280, quantity: 40, unit: "ML", fraction: 1000, amount: 11.20 },
      { id: "6", ingredientName: "Ginger Garlic Paste", rate: 120, quantity: 10, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "7", ingredientName: "Garam Masala", rate: 450, quantity: 3, unit: "GM", fraction: 1000, amount: 1.35 },
      { id: "8", ingredientName: "Cardamom Powder", rate: 1200, quantity: 1, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "9", ingredientName: "Saffron", rate: 25000, quantity: 0.1, unit: "GM", fraction: 1000, amount: 2.50 },
      { id: "10", ingredientName: "Oil", rate: 150, quantity: 15, unit: "ML", fraction: 1000, amount: 2.25 },
      { id: "11", ingredientName: "Salt", rate: 25, quantity: 4, unit: "GM", fraction: 1000, amount: 0.10 },
    ],
    landingCost: 113.85,
    sellingPrice: 445.00,
    costPercentage: 25.58,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "21",
    code: "RCP-021",
    name: "Matar Paneer",
    itemName: "Matar Paneer",
    category: "Main Course",
    cuisine: "Indian",
    yield: 330,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Paneer", rate: 320, quantity: 150, unit: "GM", fraction: 1000, amount: 48.00 },
      { id: "2", ingredientName: "Green Peas", rate: 120, quantity: 80, unit: "GM", fraction: 1000, amount: 9.60 },
      { id: "3", ingredientName: "Onion", rate: 35, quantity: 50, unit: "GM", fraction: 1000, amount: 1.75 },
      { id: "4", ingredientName: "Tomato Puree", rate: 80, quantity: 80, unit: "GM", fraction: 1000, amount: 6.40 },
      { id: "5", ingredientName: "Ginger Garlic Paste", rate: 120, quantity: 10, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "6", ingredientName: "Cumin Seeds", rate: 280, quantity: 3, unit: "GM", fraction: 1000, amount: 0.84 },
      { id: "7", ingredientName: "Coriander Powder", rate: 200, quantity: 4, unit: "GM", fraction: 1000, amount: 0.80 },
      { id: "8", ingredientName: "Garam Masala", rate: 450, quantity: 2, unit: "GM", fraction: 1000, amount: 0.90 },
      { id: "9", ingredientName: "Fresh Cream", rate: 280, quantity: 20, unit: "ML", fraction: 1000, amount: 5.60 },
      { id: "10", ingredientName: "Oil", rate: 150, quantity: 15, unit: "ML", fraction: 1000, amount: 2.25 },
      { id: "11", ingredientName: "Salt", rate: 25, quantity: 4, unit: "GM", fraction: 1000, amount: 0.10 },
    ],
    landingCost: 77.44,
    sellingPrice: 395.00,
    costPercentage: 19.60,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "22",
    code: "RCP-022",
    name: "Veg Kolhapuri",
    itemName: "Veg Kolhapuri",
    category: "Main Course",
    cuisine: "Indian",
    yield: 350,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Mixed Vegetables", rate: 60, quantity: 200, unit: "GM", fraction: 1000, amount: 12.00 },
      { id: "2", ingredientName: "Onion", rate: 35, quantity: 60, unit: "GM", fraction: 1000, amount: 2.10 },
      { id: "3", ingredientName: "Tomato", rate: 40, quantity: 80, unit: "GM", fraction: 1000, amount: 3.20 },
      { id: "4", ingredientName: "Kolhapuri Masala", rate: 420, quantity: 12, unit: "GM", fraction: 1000, amount: 5.04 },
      { id: "5", ingredientName: "Ginger Garlic Paste", rate: 120, quantity: 10, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "6", ingredientName: "Red Chilli Powder", rate: 350, quantity: 5, unit: "GM", fraction: 1000, amount: 1.75 },
      { id: "7", ingredientName: "Coriander Powder", rate: 200, quantity: 5, unit: "GM", fraction: 1000, amount: 1.00 },
      { id: "8", ingredientName: "Fresh Coriander", rate: 120, quantity: 10, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "9", ingredientName: "Oil", rate: 150, quantity: 20, unit: "ML", fraction: 1000, amount: 3.00 },
      { id: "10", ingredientName: "Salt", rate: 25, quantity: 4, unit: "GM", fraction: 1000, amount: 0.10 },
    ],
    landingCost: 30.59,
    sellingPrice: 365.00,
    costPercentage: 8.38,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "23",
    code: "RCP-023",
    name: "Jeera Rice",
    itemName: "Jeera Rice",
    category: "Rice",
    cuisine: "Indian",
    yield: 280,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Basmati Rice", rate: 180, quantity: 150, unit: "GM", fraction: 1000, amount: 27.00 },
      { id: "2", ingredientName: "Cumin Seeds", rate: 280, quantity: 5, unit: "GM", fraction: 1000, amount: 1.40 },
      { id: "3", ingredientName: "Ghee", rate: 550, quantity: 15, unit: "GM", fraction: 1000, amount: 8.25 },
      { id: "4", ingredientName: "Bay Leaf", rate: 400, quantity: 1, unit: "GM", fraction: 1000, amount: 0.40 },
      { id: "5", ingredientName: "Salt", rate: 25, quantity: 3, unit: "GM", fraction: 1000, amount: 0.08 },
    ],
    landingCost: 37.13,
    sellingPrice: 195.00,
    costPercentage: 19.04,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "24",
    code: "RCP-024",
    name: "Veg Biryani",
    itemName: "Veg Biryani",
    category: "Rice",
    cuisine: "Indian",
    yield: 400,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Basmati Rice", rate: 180, quantity: 180, unit: "GM", fraction: 1000, amount: 32.40 },
      { id: "2", ingredientName: "Mixed Vegetables", rate: 60, quantity: 120, unit: "GM", fraction: 1000, amount: 7.20 },
      { id: "3", ingredientName: "Onion", rate: 35, quantity: 80, unit: "GM", fraction: 1000, amount: 2.80 },
      { id: "4", ingredientName: "Yogurt", rate: 80, quantity: 40, unit: "GM", fraction: 1000, amount: 3.20 },
      { id: "5", ingredientName: "Biryani Masala", rate: 480, quantity: 10, unit: "GM", fraction: 1000, amount: 4.80 },
      { id: "6", ingredientName: "Ginger Garlic Paste", rate: 120, quantity: 12, unit: "GM", fraction: 1000, amount: 1.44 },
      { id: "7", ingredientName: "Ghee", rate: 550, quantity: 25, unit: "GM", fraction: 1000, amount: 13.75 },
      { id: "8", ingredientName: "Saffron", rate: 25000, quantity: 0.1, unit: "GM", fraction: 1000, amount: 2.50 },
      { id: "9", ingredientName: "Mint Leaves", rate: 200, quantity: 8, unit: "GM", fraction: 1000, amount: 1.60 },
      { id: "10", ingredientName: "Fresh Coriander", rate: 120, quantity: 10, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "11", ingredientName: "Salt", rate: 25, quantity: 5, unit: "GM", fraction: 1000, amount: 0.13 },
    ],
    landingCost: 71.02,
    sellingPrice: 345.00,
    costPercentage: 20.59,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "25",
    code: "RCP-025",
    name: "Butter Naan",
    itemName: "Butter Naan",
    category: "Breads",
    cuisine: "Indian",
    yield: 80,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Maida", rate: 45, quantity: 60, unit: "GM", fraction: 1000, amount: 2.70 },
      { id: "2", ingredientName: "Yogurt", rate: 80, quantity: 15, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "3", ingredientName: "Butter", rate: 480, quantity: 10, unit: "GM", fraction: 1000, amount: 4.80 },
      { id: "4", ingredientName: "Yeast", rate: 350, quantity: 1, unit: "GM", fraction: 1000, amount: 0.35 },
      { id: "5", ingredientName: "Sugar", rate: 80, quantity: 3, unit: "GM", fraction: 1000, amount: 0.24 },
      { id: "6", ingredientName: "Salt", rate: 25, quantity: 1, unit: "GM", fraction: 1000, amount: 0.03 },
    ],
    landingCost: 9.32,
    sellingPrice: 75.00,
    costPercentage: 12.43,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "26",
    code: "RCP-026",
    name: "Garlic Naan",
    itemName: "Garlic Naan",
    category: "Breads",
    cuisine: "Indian",
    yield: 85,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Maida", rate: 45, quantity: 60, unit: "GM", fraction: 1000, amount: 2.70 },
      { id: "2", ingredientName: "Yogurt", rate: 80, quantity: 15, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "3", ingredientName: "Butter", rate: 480, quantity: 10, unit: "GM", fraction: 1000, amount: 4.80 },
      { id: "4", ingredientName: "Garlic Chopped", rate: 120, quantity: 8, unit: "GM", fraction: 1000, amount: 0.96 },
      { id: "5", ingredientName: "Fresh Coriander", rate: 120, quantity: 3, unit: "GM", fraction: 1000, amount: 0.36 },
      { id: "6", ingredientName: "Yeast", rate: 350, quantity: 1, unit: "GM", fraction: 1000, amount: 0.35 },
      { id: "7", ingredientName: "Salt", rate: 25, quantity: 1, unit: "GM", fraction: 1000, amount: 0.03 },
    ],
    landingCost: 10.40,
    sellingPrice: 85.00,
    costPercentage: 12.24,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  // =====================================================
  // PAGE 3 - INDIAN STARTERS / TANDOOR
  // =====================================================
  {
    id: "27",
    code: "RCP-027",
    name: "Paneer Tikka",
    itemName: "Paneer Tikka",
    category: "Starters",
    cuisine: "Indian",
    yield: 250,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Paneer", rate: 320, quantity: 200, unit: "GM", fraction: 1000, amount: 64.00 },
      { id: "2", ingredientName: "Yogurt", rate: 80, quantity: 40, unit: "GM", fraction: 1000, amount: 3.20 },
      { id: "3", ingredientName: "Capsicum", rate: 80, quantity: 30, unit: "GM", fraction: 1000, amount: 2.40 },
      { id: "4", ingredientName: "Onion", rate: 35, quantity: 30, unit: "GM", fraction: 1000, amount: 1.05 },
      { id: "5", ingredientName: "Tikka Masala", rate: 400, quantity: 10, unit: "GM", fraction: 1000, amount: 4.00 },
      { id: "6", ingredientName: "Ginger Garlic Paste", rate: 120, quantity: 8, unit: "GM", fraction: 1000, amount: 0.96 },
      { id: "7", ingredientName: "Red Chilli Powder", rate: 350, quantity: 3, unit: "GM", fraction: 1000, amount: 1.05 },
      { id: "8", ingredientName: "Lemon Juice", rate: 80, quantity: 5, unit: "ML", fraction: 1000, amount: 0.40 },
      { id: "9", ingredientName: "Oil", rate: 150, quantity: 15, unit: "ML", fraction: 1000, amount: 2.25 },
      { id: "10", ingredientName: "Salt", rate: 25, quantity: 3, unit: "GM", fraction: 1000, amount: 0.08 },
    ],
    landingCost: 79.39,
    sellingPrice: 425.00,
    costPercentage: 18.68,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "28",
    code: "RCP-028",
    name: "Malai Paneer Tikka",
    itemName: "Malai Paneer Tikka",
    category: "Starters",
    cuisine: "Indian",
    yield: 250,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Paneer", rate: 320, quantity: 200, unit: "GM", fraction: 1000, amount: 64.00 },
      { id: "2", ingredientName: "Fresh Cream", rate: 280, quantity: 40, unit: "ML", fraction: 1000, amount: 11.20 },
      { id: "3", ingredientName: "Cheese", rate: 450, quantity: 20, unit: "GM", fraction: 1000, amount: 9.00 },
      { id: "4", ingredientName: "Cashew Paste", rate: 850, quantity: 15, unit: "GM", fraction: 1000, amount: 12.75 },
      { id: "5", ingredientName: "Ginger Garlic Paste", rate: 120, quantity: 8, unit: "GM", fraction: 1000, amount: 0.96 },
      { id: "6", ingredientName: "White Pepper", rate: 400, quantity: 2, unit: "GM", fraction: 1000, amount: 0.80 },
      { id: "7", ingredientName: "Cardamom Powder", rate: 1200, quantity: 1, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "8", ingredientName: "Oil", rate: 150, quantity: 10, unit: "ML", fraction: 1000, amount: 1.50 },
      { id: "9", ingredientName: "Salt", rate: 25, quantity: 3, unit: "GM", fraction: 1000, amount: 0.08 },
    ],
    landingCost: 101.49,
    sellingPrice: 445.00,
    costPercentage: 22.81,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "29",
    code: "RCP-029",
    name: "Achari Paneer Tikka",
    itemName: "Achari Paneer Tikka",
    category: "Starters",
    cuisine: "Indian",
    yield: 250,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Paneer", rate: 320, quantity: 200, unit: "GM", fraction: 1000, amount: 64.00 },
      { id: "2", ingredientName: "Yogurt", rate: 80, quantity: 40, unit: "GM", fraction: 1000, amount: 3.20 },
      { id: "3", ingredientName: "Achari Masala", rate: 380, quantity: 12, unit: "GM", fraction: 1000, amount: 4.56 },
      { id: "4", ingredientName: "Mustard Oil", rate: 180, quantity: 15, unit: "ML", fraction: 1000, amount: 2.70 },
      { id: "5", ingredientName: "Ginger Garlic Paste", rate: 120, quantity: 8, unit: "GM", fraction: 1000, amount: 0.96 },
      { id: "6", ingredientName: "Red Chilli Powder", rate: 350, quantity: 3, unit: "GM", fraction: 1000, amount: 1.05 },
      { id: "7", ingredientName: "Fenugreek Seeds", rate: 200, quantity: 2, unit: "GM", fraction: 1000, amount: 0.40 },
      { id: "8", ingredientName: "Fennel Seeds", rate: 250, quantity: 2, unit: "GM", fraction: 1000, amount: 0.50 },
      { id: "9", ingredientName: "Salt", rate: 25, quantity: 3, unit: "GM", fraction: 1000, amount: 0.08 },
    ],
    landingCost: 77.45,
    sellingPrice: 425.00,
    costPercentage: 18.22,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "30",
    code: "RCP-030",
    name: "Hara Bhara Kebab",
    itemName: "Hara Bhara Kebab",
    category: "Starters",
    cuisine: "Indian",
    yield: 180,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Spinach", rate: 60, quantity: 100, unit: "GM", fraction: 1000, amount: 6.00 },
      { id: "2", ingredientName: "Green Peas", rate: 120, quantity: 80, unit: "GM", fraction: 1000, amount: 9.60 },
      { id: "3", ingredientName: "Potato", rate: 30, quantity: 60, unit: "GM", fraction: 1000, amount: 1.80 },
      { id: "4", ingredientName: "Paneer", rate: 320, quantity: 40, unit: "GM", fraction: 1000, amount: 12.80 },
      { id: "5", ingredientName: "Green Chilli", rate: 80, quantity: 5, unit: "GM", fraction: 1000, amount: 0.40 },
      { id: "6", ingredientName: "Ginger", rate: 120, quantity: 5, unit: "GM", fraction: 1000, amount: 0.60 },
      { id: "7", ingredientName: "Chaat Masala", rate: 300, quantity: 3, unit: "GM", fraction: 1000, amount: 0.90 },
      { id: "8", ingredientName: "Cornflour", rate: 80, quantity: 15, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "9", ingredientName: "Oil", rate: 150, quantity: 20, unit: "ML", fraction: 1000, amount: 3.00 },
      { id: "10", ingredientName: "Salt", rate: 25, quantity: 3, unit: "GM", fraction: 1000, amount: 0.08 },
    ],
    landingCost: 36.38,
    sellingPrice: 295.00,
    costPercentage: 12.33,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "31",
    code: "RCP-031",
    name: "Dahi Ke Kebab",
    itemName: "Dahi Ke Kebab",
    category: "Starters",
    cuisine: "Indian",
    yield: 160,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Hung Curd", rate: 120, quantity: 150, unit: "GM", fraction: 1000, amount: 18.00 },
      { id: "2", ingredientName: "Paneer", rate: 320, quantity: 50, unit: "GM", fraction: 1000, amount: 16.00 },
      { id: "3", ingredientName: "Cashew", rate: 850, quantity: 15, unit: "GM", fraction: 1000, amount: 12.75 },
      { id: "4", ingredientName: "Green Chilli", rate: 80, quantity: 5, unit: "GM", fraction: 1000, amount: 0.40 },
      { id: "5", ingredientName: "Fresh Coriander", rate: 120, quantity: 8, unit: "GM", fraction: 1000, amount: 0.96 },
      { id: "6", ingredientName: "Roasted Cumin", rate: 320, quantity: 3, unit: "GM", fraction: 1000, amount: 0.96 },
      { id: "7", ingredientName: "Cornflour", rate: 80, quantity: 20, unit: "GM", fraction: 1000, amount: 1.60 },
      { id: "8", ingredientName: "Oil", rate: 150, quantity: 25, unit: "ML", fraction: 1000, amount: 3.75 },
      { id: "9", ingredientName: "Salt", rate: 25, quantity: 2, unit: "GM", fraction: 1000, amount: 0.05 },
    ],
    landingCost: 54.47,
    sellingPrice: 325.00,
    costPercentage: 16.76,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "32",
    code: "RCP-032",
    name: "Tandoori Mushroom",
    itemName: "Tandoori Mushroom",
    category: "Starters",
    cuisine: "Indian",
    yield: 200,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Button Mushroom", rate: 180, quantity: 200, unit: "GM", fraction: 1000, amount: 36.00 },
      { id: "2", ingredientName: "Yogurt", rate: 80, quantity: 40, unit: "GM", fraction: 1000, amount: 3.20 },
      { id: "3", ingredientName: "Tandoori Masala", rate: 380, quantity: 10, unit: "GM", fraction: 1000, amount: 3.80 },
      { id: "4", ingredientName: "Ginger Garlic Paste", rate: 120, quantity: 8, unit: "GM", fraction: 1000, amount: 0.96 },
      { id: "5", ingredientName: "Red Chilli Powder", rate: 350, quantity: 3, unit: "GM", fraction: 1000, amount: 1.05 },
      { id: "6", ingredientName: "Lemon Juice", rate: 80, quantity: 5, unit: "ML", fraction: 1000, amount: 0.40 },
      { id: "7", ingredientName: "Oil", rate: 150, quantity: 15, unit: "ML", fraction: 1000, amount: 2.25 },
      { id: "8", ingredientName: "Salt", rate: 25, quantity: 3, unit: "GM", fraction: 1000, amount: 0.08 },
    ],
    landingCost: 47.74,
    sellingPrice: 345.00,
    costPercentage: 13.84,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "33",
    code: "RCP-033",
    name: "Stuffed Tandoori Aloo",
    itemName: "Stuffed Tandoori Aloo",
    category: "Starters",
    cuisine: "Indian",
    yield: 220,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Baby Potato", rate: 50, quantity: 200, unit: "GM", fraction: 1000, amount: 10.00 },
      { id: "2", ingredientName: "Paneer", rate: 320, quantity: 40, unit: "GM", fraction: 1000, amount: 12.80 },
      { id: "3", ingredientName: "Cashew", rate: 850, quantity: 15, unit: "GM", fraction: 1000, amount: 12.75 },
      { id: "4", ingredientName: "Yogurt", rate: 80, quantity: 30, unit: "GM", fraction: 1000, amount: 2.40 },
      { id: "5", ingredientName: "Tandoori Masala", rate: 380, quantity: 8, unit: "GM", fraction: 1000, amount: 3.04 },
      { id: "6", ingredientName: "Ginger Garlic Paste", rate: 120, quantity: 6, unit: "GM", fraction: 1000, amount: 0.72 },
      { id: "7", ingredientName: "Fresh Coriander", rate: 120, quantity: 5, unit: "GM", fraction: 1000, amount: 0.60 },
      { id: "8", ingredientName: "Oil", rate: 150, quantity: 15, unit: "ML", fraction: 1000, amount: 2.25 },
      { id: "9", ingredientName: "Salt", rate: 25, quantity: 3, unit: "GM", fraction: 1000, amount: 0.08 },
    ],
    landingCost: 44.64,
    sellingPrice: 325.00,
    costPercentage: 13.74,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "34",
    code: "RCP-034",
    name: "Veg Seekh Kebab",
    itemName: "Veg Seekh Kebab",
    category: "Starters",
    cuisine: "Indian",
    yield: 180,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Mixed Vegetables", rate: 60, quantity: 100, unit: "GM", fraction: 1000, amount: 6.00 },
      { id: "2", ingredientName: "Paneer", rate: 320, quantity: 50, unit: "GM", fraction: 1000, amount: 16.00 },
      { id: "3", ingredientName: "Onion", rate: 35, quantity: 30, unit: "GM", fraction: 1000, amount: 1.05 },
      { id: "4", ingredientName: "Green Chilli", rate: 80, quantity: 5, unit: "GM", fraction: 1000, amount: 0.40 },
      { id: "5", ingredientName: "Ginger Garlic Paste", rate: 120, quantity: 8, unit: "GM", fraction: 1000, amount: 0.96 },
      { id: "6", ingredientName: "Seekh Kebab Masala", rate: 400, quantity: 8, unit: "GM", fraction: 1000, amount: 3.20 },
      { id: "7", ingredientName: "Fresh Coriander", rate: 120, quantity: 8, unit: "GM", fraction: 1000, amount: 0.96 },
      { id: "8", ingredientName: "Cornflour", rate: 80, quantity: 15, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "9", ingredientName: "Oil", rate: 150, quantity: 15, unit: "ML", fraction: 1000, amount: 2.25 },
      { id: "10", ingredientName: "Salt", rate: 25, quantity: 3, unit: "GM", fraction: 1000, amount: 0.08 },
    ],
    landingCost: 32.10,
    sellingPrice: 325.00,
    costPercentage: 9.88,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  // =====================================================
  // PAGE 4 - CONTINENTAL / ITALIAN / MEXICAN
  // =====================================================
  {
    id: "35",
    code: "RCP-035",
    name: "Margherita Pizza",
    itemName: "Margherita Pizza",
    category: "Pizza",
    cuisine: "Italian",
    yield: 350,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Pizza Dough", rate: 50, quantity: 200, unit: "GM", fraction: 1000, amount: 10.00 },
      { id: "2", ingredientName: "Tomato Sauce", rate: 120, quantity: 60, unit: "GM", fraction: 1000, amount: 7.20 },
      { id: "3", ingredientName: "Mozzarella Cheese", rate: 550, quantity: 120, unit: "GM", fraction: 1000, amount: 66.00 },
      { id: "4", ingredientName: "Fresh Basil", rate: 300, quantity: 5, unit: "GM", fraction: 1000, amount: 1.50 },
      { id: "5", ingredientName: "Olive Oil", rate: 600, quantity: 10, unit: "ML", fraction: 1000, amount: 6.00 },
      { id: "6", ingredientName: "Oregano", rate: 400, quantity: 2, unit: "GM", fraction: 1000, amount: 0.80 },
      { id: "7", ingredientName: "Salt", rate: 25, quantity: 2, unit: "GM", fraction: 1000, amount: 0.05 },
    ],
    landingCost: 91.55,
    sellingPrice: 395.00,
    costPercentage: 23.18,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "36",
    code: "RCP-036",
    name: "Farmhouse Pizza",
    itemName: "Farmhouse Pizza",
    category: "Pizza",
    cuisine: "Italian",
    yield: 400,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Pizza Dough", rate: 50, quantity: 200, unit: "GM", fraction: 1000, amount: 10.00 },
      { id: "2", ingredientName: "Tomato Sauce", rate: 120, quantity: 60, unit: "GM", fraction: 1000, amount: 7.20 },
      { id: "3", ingredientName: "Mozzarella Cheese", rate: 550, quantity: 100, unit: "GM", fraction: 1000, amount: 55.00 },
      { id: "4", ingredientName: "Capsicum", rate: 80, quantity: 30, unit: "GM", fraction: 1000, amount: 2.40 },
      { id: "5", ingredientName: "Onion", rate: 35, quantity: 25, unit: "GM", fraction: 1000, amount: 0.88 },
      { id: "6", ingredientName: "Tomato", rate: 40, quantity: 30, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "7", ingredientName: "Mushroom", rate: 180, quantity: 25, unit: "GM", fraction: 1000, amount: 4.50 },
      { id: "8", ingredientName: "Black Olives", rate: 350, quantity: 15, unit: "GM", fraction: 1000, amount: 5.25 },
      { id: "9", ingredientName: "Olive Oil", rate: 600, quantity: 10, unit: "ML", fraction: 1000, amount: 6.00 },
      { id: "10", ingredientName: "Oregano", rate: 400, quantity: 2, unit: "GM", fraction: 1000, amount: 0.80 },
    ],
    landingCost: 93.23,
    sellingPrice: 445.00,
    costPercentage: 20.95,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "37",
    code: "RCP-037",
    name: "Penne Arrabiata",
    itemName: "Penne Arrabiata",
    category: "Pasta",
    cuisine: "Italian",
    yield: 320,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Penne Pasta", rate: 180, quantity: 150, unit: "GM", fraction: 1000, amount: 27.00 },
      { id: "2", ingredientName: "Tomato Sauce", rate: 120, quantity: 100, unit: "GM", fraction: 1000, amount: 12.00 },
      { id: "3", ingredientName: "Garlic", rate: 120, quantity: 10, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "4", ingredientName: "Red Chilli Flakes", rate: 400, quantity: 5, unit: "GM", fraction: 1000, amount: 2.00 },
      { id: "5", ingredientName: "Olive Oil", rate: 600, quantity: 20, unit: "ML", fraction: 1000, amount: 12.00 },
      { id: "6", ingredientName: "Fresh Basil", rate: 300, quantity: 5, unit: "GM", fraction: 1000, amount: 1.50 },
      { id: "7", ingredientName: "Parmesan", rate: 1200, quantity: 15, unit: "GM", fraction: 1000, amount: 18.00 },
      { id: "8", ingredientName: "Salt", rate: 25, quantity: 3, unit: "GM", fraction: 1000, amount: 0.08 },
    ],
    landingCost: 73.78,
    sellingPrice: 365.00,
    costPercentage: 20.21,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "38",
    code: "RCP-038",
    name: "Alfredo Pasta",
    itemName: "Alfredo Pasta",
    category: "Pasta",
    cuisine: "Italian",
    yield: 350,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Fettuccine Pasta", rate: 200, quantity: 150, unit: "GM", fraction: 1000, amount: 30.00 },
      { id: "2", ingredientName: "Heavy Cream", rate: 350, quantity: 100, unit: "ML", fraction: 1000, amount: 35.00 },
      { id: "3", ingredientName: "Butter", rate: 480, quantity: 30, unit: "GM", fraction: 1000, amount: 14.40 },
      { id: "4", ingredientName: "Parmesan", rate: 1200, quantity: 40, unit: "GM", fraction: 1000, amount: 48.00 },
      { id: "5", ingredientName: "Garlic", rate: 120, quantity: 8, unit: "GM", fraction: 1000, amount: 0.96 },
      { id: "6", ingredientName: "White Pepper", rate: 400, quantity: 2, unit: "GM", fraction: 1000, amount: 0.80 },
      { id: "7", ingredientName: "Fresh Parsley", rate: 250, quantity: 5, unit: "GM", fraction: 1000, amount: 1.25 },
      { id: "8", ingredientName: "Salt", rate: 25, quantity: 3, unit: "GM", fraction: 1000, amount: 0.08 },
    ],
    landingCost: 130.49,
    sellingPrice: 395.00,
    costPercentage: 33.04,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "39",
    code: "RCP-039",
    name: "Aglio Olio",
    itemName: "Aglio Olio",
    category: "Pasta",
    cuisine: "Italian",
    yield: 300,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Spaghetti", rate: 180, quantity: 150, unit: "GM", fraction: 1000, amount: 27.00 },
      { id: "2", ingredientName: "Garlic", rate: 120, quantity: 20, unit: "GM", fraction: 1000, amount: 2.40 },
      { id: "3", ingredientName: "Olive Oil", rate: 600, quantity: 40, unit: "ML", fraction: 1000, amount: 24.00 },
      { id: "4", ingredientName: "Red Chilli Flakes", rate: 400, quantity: 4, unit: "GM", fraction: 1000, amount: 1.60 },
      { id: "5", ingredientName: "Fresh Parsley", rate: 250, quantity: 8, unit: "GM", fraction: 1000, amount: 2.00 },
      { id: "6", ingredientName: "Parmesan", rate: 1200, quantity: 15, unit: "GM", fraction: 1000, amount: 18.00 },
      { id: "7", ingredientName: "Salt", rate: 25, quantity: 3, unit: "GM", fraction: 1000, amount: 0.08 },
    ],
    landingCost: 75.08,
    sellingPrice: 345.00,
    costPercentage: 21.76,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "40",
    code: "RCP-040",
    name: "Lasagna",
    itemName: "Lasagna",
    category: "Pasta",
    cuisine: "Italian",
    yield: 400,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Lasagna Sheets", rate: 250, quantity: 120, unit: "GM", fraction: 1000, amount: 30.00 },
      { id: "2", ingredientName: "Bechamel Sauce", rate: 150, quantity: 100, unit: "GM", fraction: 1000, amount: 15.00 },
      { id: "3", ingredientName: "Tomato Sauce", rate: 120, quantity: 80, unit: "GM", fraction: 1000, amount: 9.60 },
      { id: "4", ingredientName: "Mozzarella Cheese", rate: 550, quantity: 80, unit: "GM", fraction: 1000, amount: 44.00 },
      { id: "5", ingredientName: "Parmesan", rate: 1200, quantity: 20, unit: "GM", fraction: 1000, amount: 24.00 },
      { id: "6", ingredientName: "Mixed Vegetables", rate: 60, quantity: 80, unit: "GM", fraction: 1000, amount: 4.80 },
      { id: "7", ingredientName: "Oregano", rate: 400, quantity: 2, unit: "GM", fraction: 1000, amount: 0.80 },
      { id: "8", ingredientName: "Salt", rate: 25, quantity: 3, unit: "GM", fraction: 1000, amount: 0.08 },
    ],
    landingCost: 128.28,
    sellingPrice: 445.00,
    costPercentage: 28.83,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "41",
    code: "RCP-041",
    name: "Bruschetta",
    itemName: "Bruschetta",
    category: "Starters",
    cuisine: "Italian",
    yield: 150,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Baguette", rate: 120, quantity: 80, unit: "GM", fraction: 1000, amount: 9.60 },
      { id: "2", ingredientName: "Tomato", rate: 40, quantity: 60, unit: "GM", fraction: 1000, amount: 2.40 },
      { id: "3", ingredientName: "Fresh Basil", rate: 300, quantity: 5, unit: "GM", fraction: 1000, amount: 1.50 },
      { id: "4", ingredientName: "Garlic", rate: 120, quantity: 5, unit: "GM", fraction: 1000, amount: 0.60 },
      { id: "5", ingredientName: "Olive Oil", rate: 600, quantity: 15, unit: "ML", fraction: 1000, amount: 9.00 },
      { id: "6", ingredientName: "Balsamic Vinegar", rate: 450, quantity: 5, unit: "ML", fraction: 1000, amount: 2.25 },
      { id: "7", ingredientName: "Salt", rate: 25, quantity: 2, unit: "GM", fraction: 1000, amount: 0.05 },
    ],
    landingCost: 25.40,
    sellingPrice: 245.00,
    costPercentage: 10.37,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "42",
    code: "RCP-042",
    name: "Garlic Bread",
    itemName: "Garlic Bread",
    category: "Starters",
    cuisine: "Italian",
    yield: 120,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Baguette", rate: 120, quantity: 100, unit: "GM", fraction: 1000, amount: 12.00 },
      { id: "2", ingredientName: "Butter", rate: 480, quantity: 25, unit: "GM", fraction: 1000, amount: 12.00 },
      { id: "3", ingredientName: "Garlic", rate: 120, quantity: 10, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "4", ingredientName: "Fresh Parsley", rate: 250, quantity: 5, unit: "GM", fraction: 1000, amount: 1.25 },
      { id: "5", ingredientName: "Salt", rate: 25, quantity: 1, unit: "GM", fraction: 1000, amount: 0.03 },
    ],
    landingCost: 26.48,
    sellingPrice: 175.00,
    costPercentage: 15.13,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "43",
    code: "RCP-043",
    name: "Cheese Garlic Bread",
    itemName: "Cheese Garlic Bread",
    category: "Starters",
    cuisine: "Italian",
    yield: 150,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Baguette", rate: 120, quantity: 100, unit: "GM", fraction: 1000, amount: 12.00 },
      { id: "2", ingredientName: "Butter", rate: 480, quantity: 20, unit: "GM", fraction: 1000, amount: 9.60 },
      { id: "3", ingredientName: "Mozzarella Cheese", rate: 550, quantity: 40, unit: "GM", fraction: 1000, amount: 22.00 },
      { id: "4", ingredientName: "Garlic", rate: 120, quantity: 10, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "5", ingredientName: "Fresh Parsley", rate: 250, quantity: 5, unit: "GM", fraction: 1000, amount: 1.25 },
      { id: "6", ingredientName: "Oregano", rate: 400, quantity: 1, unit: "GM", fraction: 1000, amount: 0.40 },
    ],
    landingCost: 46.45,
    sellingPrice: 225.00,
    costPercentage: 20.64,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "44",
    code: "RCP-044",
    name: "Caesar Salad",
    itemName: "Caesar Salad",
    category: "Salads",
    cuisine: "Continental",
    yield: 250,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Romaine Lettuce", rate: 180, quantity: 150, unit: "GM", fraction: 1000, amount: 27.00 },
      { id: "2", ingredientName: "Caesar Dressing", rate: 350, quantity: 40, unit: "GM", fraction: 1000, amount: 14.00 },
      { id: "3", ingredientName: "Parmesan", rate: 1200, quantity: 20, unit: "GM", fraction: 1000, amount: 24.00 },
      { id: "4", ingredientName: "Croutons", rate: 200, quantity: 30, unit: "GM", fraction: 1000, amount: 6.00 },
      { id: "5", ingredientName: "Black Pepper", rate: 500, quantity: 2, unit: "GM", fraction: 1000, amount: 1.00 },
    ],
    landingCost: 72.00,
    sellingPrice: 345.00,
    costPercentage: 20.87,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "45",
    code: "RCP-045",
    name: "Greek Salad",
    itemName: "Greek Salad",
    category: "Salads",
    cuisine: "Continental",
    yield: 280,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Cucumber", rate: 50, quantity: 80, unit: "GM", fraction: 1000, amount: 4.00 },
      { id: "2", ingredientName: "Tomato", rate: 40, quantity: 80, unit: "GM", fraction: 1000, amount: 3.20 },
      { id: "3", ingredientName: "Onion", rate: 35, quantity: 30, unit: "GM", fraction: 1000, amount: 1.05 },
      { id: "4", ingredientName: "Feta Cheese", rate: 800, quantity: 50, unit: "GM", fraction: 1000, amount: 40.00 },
      { id: "5", ingredientName: "Black Olives", rate: 350, quantity: 20, unit: "GM", fraction: 1000, amount: 7.00 },
      { id: "6", ingredientName: "Olive Oil", rate: 600, quantity: 20, unit: "ML", fraction: 1000, amount: 12.00 },
      { id: "7", ingredientName: "Oregano", rate: 400, quantity: 2, unit: "GM", fraction: 1000, amount: 0.80 },
      { id: "8", ingredientName: "Salt", rate: 25, quantity: 2, unit: "GM", fraction: 1000, amount: 0.05 },
    ],
    landingCost: 68.10,
    sellingPrice: 325.00,
    costPercentage: 20.95,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "46",
    code: "RCP-046",
    name: "Veg Quesadilla",
    itemName: "Veg Quesadilla",
    category: "Mexican",
    cuisine: "Mexican",
    yield: 280,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Flour Tortilla", rate: 150, quantity: 100, unit: "GM", fraction: 1000, amount: 15.00 },
      { id: "2", ingredientName: "Cheddar Cheese", rate: 600, quantity: 60, unit: "GM", fraction: 1000, amount: 36.00 },
      { id: "3", ingredientName: "Capsicum", rate: 80, quantity: 30, unit: "GM", fraction: 1000, amount: 2.40 },
      { id: "4", ingredientName: "Onion", rate: 35, quantity: 25, unit: "GM", fraction: 1000, amount: 0.88 },
      { id: "5", ingredientName: "Jalapeno", rate: 250, quantity: 10, unit: "GM", fraction: 1000, amount: 2.50 },
      { id: "6", ingredientName: "Salsa", rate: 200, quantity: 30, unit: "GM", fraction: 1000, amount: 6.00 },
      { id: "7", ingredientName: "Sour Cream", rate: 400, quantity: 20, unit: "GM", fraction: 1000, amount: 8.00 },
      { id: "8", ingredientName: "Oil", rate: 150, quantity: 10, unit: "ML", fraction: 1000, amount: 1.50 },
    ],
    landingCost: 72.28,
    sellingPrice: 345.00,
    costPercentage: 20.95,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "47",
    code: "RCP-047",
    name: "Nachos with Cheese",
    itemName: "Nachos with Cheese",
    category: "Mexican",
    cuisine: "Mexican",
    yield: 300,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Nachos Chips", rate: 250, quantity: 100, unit: "GM", fraction: 1000, amount: 25.00 },
      { id: "2", ingredientName: "Cheese Sauce", rate: 350, quantity: 80, unit: "GM", fraction: 1000, amount: 28.00 },
      { id: "3", ingredientName: "Jalapeno", rate: 250, quantity: 15, unit: "GM", fraction: 1000, amount: 3.75 },
      { id: "4", ingredientName: "Salsa", rate: 200, quantity: 40, unit: "GM", fraction: 1000, amount: 8.00 },
      { id: "5", ingredientName: "Sour Cream", rate: 400, quantity: 25, unit: "GM", fraction: 1000, amount: 10.00 },
      { id: "6", ingredientName: "Guacamole", rate: 450, quantity: 30, unit: "GM", fraction: 1000, amount: 13.50 },
    ],
    landingCost: 88.25,
    sellingPrice: 375.00,
    costPercentage: 23.53,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "48",
    code: "RCP-048",
    name: "Veg Burrito",
    itemName: "Veg Burrito",
    category: "Mexican",
    cuisine: "Mexican",
    yield: 350,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Flour Tortilla", rate: 150, quantity: 80, unit: "GM", fraction: 1000, amount: 12.00 },
      { id: "2", ingredientName: "Mexican Rice", rate: 100, quantity: 80, unit: "GM", fraction: 1000, amount: 8.00 },
      { id: "3", ingredientName: "Refried Beans", rate: 120, quantity: 60, unit: "GM", fraction: 1000, amount: 7.20 },
      { id: "4", ingredientName: "Cheddar Cheese", rate: 600, quantity: 40, unit: "GM", fraction: 1000, amount: 24.00 },
      { id: "5", ingredientName: "Sour Cream", rate: 400, quantity: 25, unit: "GM", fraction: 1000, amount: 10.00 },
      { id: "6", ingredientName: "Salsa", rate: 200, quantity: 30, unit: "GM", fraction: 1000, amount: 6.00 },
      { id: "7", ingredientName: "Lettuce", rate: 100, quantity: 20, unit: "GM", fraction: 1000, amount: 2.00 },
      { id: "8", ingredientName: "Guacamole", rate: 450, quantity: 25, unit: "GM", fraction: 1000, amount: 11.25 },
    ],
    landingCost: 80.45,
    sellingPrice: 395.00,
    costPercentage: 20.37,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "49",
    code: "RCP-049",
    name: "Tacos",
    itemName: "Tacos",
    category: "Mexican",
    cuisine: "Mexican",
    yield: 200,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Taco Shells", rate: 200, quantity: 60, unit: "GM", fraction: 1000, amount: 12.00 },
      { id: "2", ingredientName: "Refried Beans", rate: 120, quantity: 40, unit: "GM", fraction: 1000, amount: 4.80 },
      { id: "3", ingredientName: "Cheddar Cheese", rate: 600, quantity: 30, unit: "GM", fraction: 1000, amount: 18.00 },
      { id: "4", ingredientName: "Lettuce", rate: 100, quantity: 20, unit: "GM", fraction: 1000, amount: 2.00 },
      { id: "5", ingredientName: "Tomato", rate: 40, quantity: 25, unit: "GM", fraction: 1000, amount: 1.00 },
      { id: "6", ingredientName: "Salsa", rate: 200, quantity: 20, unit: "GM", fraction: 1000, amount: 4.00 },
      { id: "7", ingredientName: "Sour Cream", rate: 400, quantity: 15, unit: "GM", fraction: 1000, amount: 6.00 },
    ],
    landingCost: 47.80,
    sellingPrice: 295.00,
    costPercentage: 16.20,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
  {
    id: "50",
    code: "RCP-050",
    name: "Grilled Veg Sandwich",
    itemName: "Grilled Veg Sandwich",
    category: "Sandwiches",
    cuisine: "Continental",
    yield: 250,
    yieldUnit: "gm",
    ingredients: [
      { id: "1", ingredientName: "Bread", rate: 60, quantity: 100, unit: "GM", fraction: 1000, amount: 6.00 },
      { id: "2", ingredientName: "Capsicum", rate: 80, quantity: 25, unit: "GM", fraction: 1000, amount: 2.00 },
      { id: "3", ingredientName: "Onion", rate: 35, quantity: 25, unit: "GM", fraction: 1000, amount: 0.88 },
      { id: "4", ingredientName: "Tomato", rate: 40, quantity: 30, unit: "GM", fraction: 1000, amount: 1.20 },
      { id: "5", ingredientName: "Lettuce", rate: 100, quantity: 15, unit: "GM", fraction: 1000, amount: 1.50 },
      { id: "6", ingredientName: "Cheese Slice", rate: 550, quantity: 30, unit: "GM", fraction: 1000, amount: 16.50 },
      { id: "7", ingredientName: "Mayonnaise", rate: 200, quantity: 20, unit: "GM", fraction: 1000, amount: 4.00 },
      { id: "8", ingredientName: "Butter", rate: 480, quantity: 10, unit: "GM", fraction: 1000, amount: 4.80 },
    ],
    landingCost: 36.88,
    sellingPrice: 245.00,
    costPercentage: 15.05,
    createdAt: "2024-01-15",
    updatedAt: "2024-01-15",
    status: "active"
  },
];

// Categories for recipes
export const recipeCategories = [
  "Rice",
  "Noodles",
  "Soup",
  "Starters",
  "Dimsum",
  "Sushi",
  "Main Course",
  "Desserts",
  "Base Sauces",
  "Breads",
  "Pizza",
  "Pasta",
  "Salads",
  "Mexican",
  "Sandwiches",
];

// Cuisines
export const cuisines = [
  "Indo-Chinese",
  "Thai",
  "Japanese",
  "Chinese",
  "Burmese",
  "Thai-Chinese",
  "Indian",
  "Continental",
  "Italian",
  "Mexican",
];

// Units
export const units = ["GM", "ML", "KG", "LTR", "NO", "PCS"];

// Generate recipe code
export const generateRecipeCode = (existingRecipes) => {
  const maxCode = existingRecipes.reduce((max, recipe) => {
    const num = parseInt(recipe.code.replace("RCP-", ""));
    return num > max ? num : max;
  }, 0);
  return `RCP-${String(maxCode + 1).padStart(3, "0")}`;
};

// Generate recipe name from item and variation
export const generateRecipeName = (itemName, variationName) => {
  if (variationName && variationName.trim()) {
    return `${itemName} ${variationName}`;
  }
  return itemName;
};